import { Component, Input } from '@angular/core';
import { LoginJourney } from '../login-sca-enums';
import { OtpChannel } from '../../../services/strong-customer-authentication/model';
import {
  LoggedOutEntitlement,
  LoggedOutEntitlementsService,
} from '../../../services/logged-out-entitlements.service';
import { LinkItem } from '../../../models/common';
import { AnalyticsService } from '../../../services/analytics.service';
import { GTMTracking } from '../../../enums/google-analytics-tracking';
import { ILoginJourneyDescriptionContent } from '../../../models/content';

@Component({
  selector: 'left-side-descriptions',
  templateUrl: './left-side-descriptions.component.html',
})
export class LeftSideDescriptions {
  @Input() step: LoginJourney;
  @Input() registerLink: LinkItem;
  @Input() mobileNumberEnding: string;
  @Input() homeNumberEnding: string;
  @Input() selectedOTPChannel: OtpChannel;
  @Input() journeyDescription: ILoginJourneyDescriptionContent;

  LoginJourney: typeof LoginJourney = LoginJourney;
  OtpChannel: typeof OtpChannel = OtpChannel;
  registrationAllowed: boolean;
  content: ILoginJourneyDescriptionContent['journey'];

  constructor(
    private analyticsService: AnalyticsService,
    private readonly loggedOutEntitlementsService: LoggedOutEntitlementsService
  ) {}

  async ngOnInit() {
    this.content = this.journeyDescription.journey;

    this.registrationAllowed =
      await this.loggedOutEntitlementsService.hasEntitlement(
        LoggedOutEntitlement.registrationPages
      );
  }

  onClickRegisterLink() {
    this.analyticsService.trackCtaActions(GTMTracking.LoginSignUpHereClick);
  }
}
